import React from 'react';
import { Pressable, Image } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { ChevronRight } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import type { Transaction } from '@/data/walletData';
import {
  AVATAR_SIZE,
  AVATAR_BORDER_RADIUS,
  FONT_SIZE_MD,
  FONT_SIZE_SM,
  FONT_SIZE_BASE,
  ICON_SIZE_LARGE,
  BORDER_WIDTH_THIN,
} from '../constants';

export type TransactionItemProps = {
  transaction: Transaction;
  isDark: boolean;
  textColor: string;
  subtextColor: string;
  isLast: boolean;
};

const TransactionItem: React.FC<TransactionItemProps> = React.memo(({
  transaction,
  isDark,
  textColor,
  subtextColor,
  isLast,
}) => {
  return (
    <Pressable>
      <XStack
        backgroundColor={isDark ? '#1C1C1C' : COLORS.WHITE}
        padding="$3"
        alignItems="center"
        gap="$3"
        borderBottomWidth={isLast ? 0 : BORDER_WIDTH_THIN}
        borderBottomColor={isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}
      >
        {/* Avatar */}
        <Image
          source={{ uri: transaction.avatar }}
          style={{ width: AVATAR_SIZE, height: AVATAR_SIZE, borderRadius: AVATAR_BORDER_RADIUS }}
        />

        {/* Title and Date */}
        <YStack flex={1}>
          <Text fontSize={FONT_SIZE_MD + 1} fontWeight="600" color={textColor}>
            {transaction.title}
          </Text>
          <Text fontSize={FONT_SIZE_SM} color={subtextColor} marginTop="$1">
            {transaction.date}
          </Text>
        </YStack>

        {/* Amount */}
        <Text
          fontSize={FONT_SIZE_BASE}
          fontWeight="700"
          color={transaction.type === 'income' ? COLORS.SUCCESS : COLORS.ERROR}
        >
          {transaction.amount > 0 ? '+' : ''}{transaction.amount.toFixed(2).replace('.', ',')}
        </Text>

        {/* Chevron */}
        <ChevronRight size={ICON_SIZE_LARGE} color={subtextColor} />
      </XStack>
    </Pressable>
  );
});

TransactionItem.displayName = 'TransactionItem';

export default TransactionItem;

